import { render, staticRenderFns } from "./WaterfallList.vue?vue&type=template&id=129fe5a5&scoped=true"
import script from "./WaterfallList.vue?vue&type=script&lang=js"
export * from "./WaterfallList.vue?vue&type=script&lang=js"
import style0 from "./WaterfallList.vue?vue&type=style&index=0&id=129fe5a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129fe5a5",
  null
  
)

export default component.exports